// 12-12-25

// import { Box, Button, Stack } from "@mui/material";
// import React, { Fragment } from "react";
// import axios from "axios";
// import { useDispatch } from "react-redux";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { useNavigate } from "react-router-dom";

// const StockVerificationCustomerInfo = ({ loadTempData }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   // VERIFY
//   const handleVerify = async () => {
//     try {
//       const res = await axios.post("/v1/stock_verify/verify");

//       // if backend returns body with errors (safety check)
//       if (res?.data?.errors && res.data.errors.length) {
//         const first = res.data.errors[0];
//         const msg =
//           first.reason === "BARCODE_ALREADY_VERIFIED"
//             ? "Barcode already verified"
//             : "Some barcodes failed verification";
//         dispatch(setSnackbar(true, "error", msg));
//         return;
//       }

//       dispatch(setSnackbar(true, "success", "Verification Completed"));
//       await loadTempData();
//     } catch (err) {
//       const msg =
//         err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         "Barcode already verified";
//       dispatch(setSnackbar(true, "error", msg));
//     }
//   };

//   // SAVE → CLEAR TEMP
//   const handleSave = async () => {
//     try {
//       await axios.post("/v1/stock_verify/save");
//       dispatch(setSnackbar(true, "success", "Saved & Temp Cleared"));
//       await loadTempData();
//     } catch (err) {
//       const msg =
//         err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         "Save failed";
//       dispatch(setSnackbar(true, "error", msg));
//     }
//   };

//   return (
//     <Fragment>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "flex-end",
//           position: "absolute",
//           bottom: 0,
//           right: 0,
//           padding: 2,
//         }}
//       >
//         <Stack direction="row">
//           <Button
//             variant="contained"
//             sx={{ margin: 1, backgroundColor: "blue" }}
//             onClick={handleVerify}
//           >
//             Verify
//           </Button>

//           <Button
//             variant="contained"
//             sx={{ margin: 1, backgroundColor: "green" }}
//             onClick={handleSave}
//           >
//             Save
//           </Button>
//         </Stack>
//       </Box>
//     </Fragment>
//   );
// };

// export default React.memo(StockVerificationCustomerInfo);

// 02-01-2026

import {
  Box,
  Button,
  Stack,
  Divider,
  Typography,
  CircularProgress,
} from "@mui/material";
import React, { Fragment, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useNavigate } from "react-router-dom";

const StockVerificationCustomerInfo = ({ loadTempData, hasData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const outlet_id = Number(localStorage.getItem("outlet_id"));

  const [verifyLoading, setVerifyLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  // const handleVerify = async () => {
  //   try {
  //     setVerifyLoading(true);
  //     const res = await axios.post("/v1/stock_verify/verify");

  //     dispatch(setSnackbar(true, "success", "Barcode Verified"));
  //     await loadTempData();
  //   } catch (err) {
  //     const msg =
  //       err?.response?.data?.message ||
  //       err?.response?.data?.error ||
  //       "Barcode Already Verified";
  //     dispatch(setSnackbar(true, "error", msg));
  //   } finally {
  //     setVerifyLoading(false);
  //   }
  // };
  const handleVerify = async () => {
    try {
      setVerifyLoading(true);
      // const res = await axios.post("/v1/stock_verify/verify");
      const res = await axios.post(`/v1/stock_verify/verify/${outlet_id}`);
      const { verified, errors } = res.data;

      if (errors && errors.length > 0) {
        dispatch(
          setSnackbar(
            true,
            "warning",
            `${verified.length} verified, ${errors.length} pending`
          )
        );
      } else {
        dispatch(setSnackbar(true, "success", "All barcodes verified"));
      }

      await loadTempData(); // 🔥 MUST refresh table
    } catch (err) {
      dispatch(setSnackbar(true, "error", "Verification failed"));
    } finally {
      setVerifyLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaveLoading(true);
      // await axios.post("/v1/stock_verify/save");
      await axios.post(`/v1/stock_verify/save/${outlet_id}`);
      dispatch(setSnackbar(true, "success", "Barcode verify Saved"));
      await loadTempData();
    } catch (err) {
      dispatch(setSnackbar(true, "error", "Save failed"));
    } finally {
      setSaveLoading(false);
    }
  };

  // const handleReset = async () => {
  //   try {
  //     setResetLoading(true);
  //     await axios.delete(
  //       `/v1/stock_verify/temp/${localStorage.getItem("outlet_id")}`
  //     );
  //     dispatch(setSnackbar(true, "success", "Reset completed"));
  //     await loadTempData();
  //   } catch (err) {
  //     dispatch(setSnackbar(true, "error", "Reset failed"));
  //   } finally {
  //     setResetLoading(false);
  //   }
  // };
  const disabledSx = {
    backgroundColor: "transparent !important",
    color: "rgba(0, 0, 0, 0.38) !important",
    border: "1px solid rgba(0, 0, 0, 0.23) !important",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "transparent !important",
      boxShadow: "none !important",
    },
  };
  return (
    <Fragment>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          p: 2,
          backgroundColor: "#fafafa",
        }}
      >
        <Divider sx={{ mb: 2 }} />

        <Typography variant="subtitle2" sx={{ mb: 1, color: "text.secondary" }}>
          Actions
        </Typography>

        <Stack spacing={1.5}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleVerify}
            disabled={!hasData || verifyLoading || saveLoading || resetLoading}
            startIcon={verifyLoading ? <CircularProgress size={18} /> : null}
            // sx={{ height: 42 }}
            sx={{
              height: 42,
              ...(!hasData && disabledSx),
            }}
          >
            {verifyLoading ? "Verifying..." : "Verify"}
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={handleSave}
            disabled={!hasData || verifyLoading || saveLoading || resetLoading}
            startIcon={saveLoading ? <CircularProgress size={18} /> : null}
            sx={{
              height: 42,
              ...(!hasData && disabledSx),
            }}
          >
            {saveLoading ? "Saving..." : "Save"}
          </Button>

          {/* <Button
            variant="outlined"
            color="error"
            onClick={handleReset}
            disabled={verifyLoading || saveLoading || resetLoading}
            startIcon={resetLoading ? <CircularProgress size={18} /> : null}
            sx={{ height: 42 }}
          >
            {resetLoading ? "Resetting..." : "Reset"}
          </Button> */}
        </Stack>
      </Box>
    </Fragment>
  );
};

export default React.memo(StockVerificationCustomerInfo);
